import React, { useState, useEffect } from 'react';

interface CountdownAnniversarySectionProps {
  anniversaryDate: Date;
  language: 'en' | 'mr';
}

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
}

export const CountdownAnniversarySection: React.FC<CountdownAnniversarySectionProps> = ({ anniversaryDate, language }) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0, minutes: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const eventTime = anniversaryDate.getTime();
      const difference = eventTime - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [anniversaryDate]);

  return (
    <section className="relative py-24 px-4 bg-gradient-to-b from-transparent via-rose-900/20 to-transparent">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-rose-400 mb-16">
          {language === 'mr' ? '💕 प्रेम गणना' : '💕 Countdown to Celebration'}
        </h2>

        <div className="grid grid-cols-3 gap-6 max-w-2xl mx-auto">
          <div className="text-center p-8 bg-gradient-to-b from-amber-500/20 to-rose-500/20 rounded-2xl border-2 border-amber-400/50 backdrop-blur-sm shadow-2xl shadow-amber-500/20">
            <div className="text-5xl md:text-6xl font-black text-amber-300 mb-2">
              {String(timeLeft.days).padStart(2, '0')}
            </div>
            <p className="text-sm font-bold text-amber-200 uppercase">
              {language === 'mr' ? 'दिवस' : 'Days'}
            </p>
          </div>

          <div className="text-center p-8 bg-gradient-to-b from-rose-500/20 to-amber-500/20 rounded-2xl border-2 border-rose-400/50 backdrop-blur-sm shadow-2xl shadow-rose-500/20">
            <div className="text-5xl md:text-6xl font-black text-rose-300 mb-2">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <p className="text-sm font-bold text-rose-200 uppercase">
              {language === 'mr' ? 'तास' : 'Hours'}
            </p>
          </div>

          <div className="text-center p-8 bg-gradient-to-b from-amber-500/20 to-rose-500/20 rounded-2xl border-2 border-amber-400/50 backdrop-blur-sm shadow-2xl shadow-amber-500/20">
            <div className="text-5xl md:text-6xl font-black text-amber-300 mb-2">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <p className="text-sm font-bold text-amber-200 uppercase">
              {language === 'mr' ? 'मिनिट' : 'Minutes'}
            </p>
          </div>
        </div>

        <p className="text-center mt-12 text-lg text-rose-200 font-serif italic">
          ✨ {language === 'mr' ? 'प्रेमाचा अगला पर्व आश्चर्य करण्यासाठी तयार' : 'The next chapter of our love story awaits'}
        </p>
      </div>
    </section>
  );
};
